import Head from 'next/head';

import LandingPage from 'components/LandingPage';
import PageWrapper from 'components/PageWrapper';

import { getLandingPage } from 'utils/graphcms/queries/landingPage';
import { getLocationPaths, isProduction } from 'utils/helpers';

export default function Landing({ page }) {
  return (
    <>
      {isProduction() && (
        <Head>
          <meta
            name="facebook-domain-verification"
            content="vfpztrvrax0ufkkx0ur2avjlg47nfp"
          />
        </Head>
      )}

      <PageWrapper page={page}>
        <LandingPage page={page} />
      </PageWrapper>
    </>
  );
}

export async function getStaticProps({ params: { location } }) {
  if (location === 'moorgate') {
    return {
      redirect: {
        destination: '/the-city',
        permanent: true,
      },
    };
  }

  const page = await getLandingPage(location);

  return {
    props: {
      page: page,
    },
  };
}

export const getStaticPaths = () => getLocationPaths();
